import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Fade.scss';

const propTypes = {
    show: PropTypes.bool,
    light: PropTypes.bool,
    dark: PropTypes.bool,
    slow: PropTypes.bool,
    cover: PropTypes.bool,
    disableFadeIn: PropTypes.bool,
    disableFadeOut: PropTypes.bool,
    children: PropTypes.node,
    onHideEnd: PropTypes.func,
    onShowEnd: PropTypes.func,
};
const defaultProps = {
    show: false,
    light: false,
    dark: true,
    slow: false,
    cover: false,
    children: null,
    disableFadeIn: false,
    disableFadeOut: false,
    onHideEnd: () => {},
    onShowEnd: () => {},
};

const Fade = ({ show, cover, light, dark, children, slow, disableFadeIn, disableFadeOut, onHideEnd, onShowEnd }) => {
    // const [render, setRender] = useState(show);

    useEffect(() => {
        // if (show) setRender(true);
    }, [show]);

    const onAnimationEnd = () => {
        if (!show) {
            onHideEnd();
            // setRender(false);
        } else {
            onShowEnd();
        }
    };

    const classes = classnames({
        Fade: true,
        'Fade--light': light,
        'Fade--dark': dark && !light,
        'Fade--in': show && !disableFadeIn,
        'Fade--out': !show && !disableFadeOut,
        'Fade--in-immediate': show && disableFadeIn,
        'Fade--out-immediate': !show && disableFadeOut,
        'Fade--slow': slow,
        'Fade--cover': cover,
    });

    return (
        // render && (
        <div className={classes} onAnimationEnd={onAnimationEnd}>
            {children}
        </div>
        // )
    );
};

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;

export default Fade;
